// ReactSliderComponent.jsx

import React from "react";
import ellipseRed from "../../assets/images/ellipse-red.svg";
import ellipseGreen from "../../assets/images/ellipse-green.svg";

const ReviewModalSlider = ({ minValue, maxValue, startValue, endValue }) => {
  const min = minValue;
  const max = maxValue;
  const start = startValue;
  const end = endValue;
  const totalRange = max - min;
  const leftPercentage = ((start - min) / totalRange) * 100;
  const rightPercentage = ((max - end) / totalRange) * 100;

  return (
    <div className="flex flex-col items-center w-full py-4">
      <div className="w-full text-center mb-3 sm:mb-4">
        <div className="flex flex-col items-center">
          <strong className="font-bold font-roboto text-xs sm:text-sm lg:text-base text-custom-darkGray">
            Entry Price Range
          </strong>
          <span className="font-roboto text-xs sm:text-sm text-gray-600">
            {start} - {end}
          </span>
        </div>
      </div>

      {/* Slider Bar */}
      <div className="relative w-full sm:w-[90%] h-[9px] sm:h-[10px] lg:h-[11px] bg-brand-border rounded-lg mb-3 sm:mb-4">
        {/* Stop Loss Marker (Red) */}
        <img
          src={ellipseRed}
          className="absolute left-[-8px] sm:left-[-9px] top-[-6px] sm:top-[-9px] w-[22px] h-[22px] sm:w-[28px] sm:h-[28px] lg:w-[30px] lg:h-[30px]"
          alt="Stop Loss"
        />

        {/* Target Marker (Green) */}
        <img
          src={ellipseGreen}
          className="absolute right-[-8px] sm:right-[-9px] top-[-6px] sm:top-[-9px] w-[22px] h-[22px] sm:w-[28px] sm:h-[28px] lg:w-[30px] lg:h-[30px]"
          alt="Target"
        />

        {/* Entry Price Range Bar */}
        <div
          className="absolute h-full bg-primary rounded-md"
          style={{ left: `${leftPercentage}%`, right: `${rightPercentage}%` }}
        ></div>
      </div>

      {/* Bottom Labels - Stop Loss and Target */}
      <div className="flex justify-between w-full sm:w-[90%] px-1">
        {/* Stop Loss - Left */}
        <div className="flex flex-col items-start text-left">
          <strong className="font-bold font-roboto text-xs sm:text-sm lg:text-base text-custom-darkGray">
            Stop Loss
          </strong>
          <span className="font-roboto text-xs sm:text-sm text-gray-600">
            {min}
          </span>
        </div>

        {/* Target - Right */}
        <div className="flex flex-col items-end text-right">
          <strong className="font-bold font-roboto text-xs sm:text-sm lg:text-base text-custom-darkGray">
            Target
          </strong>
          <span className="font-roboto text-xs sm:text-sm text-gray-600">
            {max}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReviewModalSlider;
